module.exports = __webpack_public_path__ + "img/privacy.8debdf03.svg";